import { swRequest } from "./sw-request.js";

export const getAttachments = () =>
  swRequest({
    path: "/api/attachments/get_all",
    method: "GET",
    params: { includeDeleted: true, includeTeamAttachments: true },
  });
